import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Home from "./routes/Home";
import { AppProvider } from "./store/appContext";

function App() {
  return (
    <AppProvider>
      <Home />
    </AppProvider>
  );
}

export default App;
